import axios from "axios";
import { API_HEADERS, AUTH_API_BASE_URL } from "../../api-config";
import { ILogin } from "../../interfaces";

export const updatePassword = async (updatedPasswordData) => {
  try {
    const result = await axios.post(
      `${AUTH_API_BASE_URL}/updatePassword`,
      { ...updatedPasswordData },
      {
        headers: API_HEADERS,
      }
    );

    return result.data;
  } catch (error) {
    // Handle error appropriately (e.g., logging, error messages)
    console.error("Error occured while trying to Update password", error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
